import React, { useState } from 'react'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineArrowsRightLeft } from "react-icons/hi2";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import { Button } from "@/components/ui/button";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { useMediaQuery } from "@/hooks/use-media-query";
import DomesticItineraryInfo from './DomesticItineraryInfo';
import PricingInfo from '../PricingInfo';
import { Label } from '@/components/ui/label';

const DomesticFlightDetailPreviewSheet = ({ open, openchange, flightInfo, isOutbount, isTwoWay, handleBookItemCallback }) => {
  const {
    flightSearchForm,
  } = useSelector((state) => state.flights);
  const searchOdDetails = flightSearchForm?.originDestination;
  const isDesktop = useMediaQuery("(min-width: 768px)");

  let totalPax = 0;
  flightSearchForm?.passengerType.forEach((type) => {
    totalPax += type.quantity;
  })

  const odDetails = []
  return (
    <Sheet open={open} onOpenChange={(e) => openchange(e)}>
      <SheetContent className="w-full sm:max-w-[640px] lg:min-w-[640px] flex-col flex h-dvh p-0 gap-0">
        <SheetHeader className="p-3">
          <SheetTitle>
            <>
              <div className="flex items-center text-xs lg:text-base gap-x-1 text-muted-foreground mb-2">

                <span className="block">•</span>
                <span>Economy</span>
                <span className="block">•</span>

                {isDesktop ?
                  <span>
                    {totalPax == 1
                      ? totalPax +
                      " Passenger"
                      : totalPax +
                      " Passengers"}
                  </span>
                  :
                  <span className="flex items-center space-x-2">
                    <span>{totalPax}</span>
                    <FaPersonWalkingLuggage />
                  </span>
                }
                <span className="block">•</span>
                {searchOdDetails && <span>
                  {moment(searchOdDetails[0].departDateTime).format(
                    "ll"
                  )}
                </span>}
                {searchOdDetails > 1 && (
                  <>
                    <span className="block">•</span>
                    <span>
                      {moment(
                        searchOdDetails[1].departDateTime
                      ).format("ll")}
                    </span>
                  </>
                )}
              </div>
              {searchOdDetails && <div className="flex items-center text-xl gap-x-1">
                {searchOdDetails.length > 1 ? (
                  <>
                    <span>{searchOdDetails[0].origin}</span>
                    <HiOutlineArrowsRightLeft />
                    <span>{searchOdDetails[0].destination}</span>
                  </>
                ) : (
                  <>
                    <span>{searchOdDetails[0].origin}</span>
                    <HiOutlineArrowSmRight />
                    <span>{searchOdDetails[0].destination}</span>
                  </>
                )}
              </div>}
            </>
          </SheetTitle>
        </SheetHeader>
        <SheetDescription className="flex-1 overflow-auto p-3">
          {/* <Tabs defaultValue="itinerary" className="text-foreground"> */}
          {/* <TabsList className="grid w-full h-auto"> */}
          {/* <TabsTrigger
                value="itinerary"
                className="bg-transparent text-lg px-4 py-3 rounded-none border-b-2 border-transparent
               data-[state=active]:border-primary"
              > */}
          {/* </TabsTrigger> */}
          {/* <TabsTrigger
                value="farerules"
              //   className="bg-transparent text-lg px-4 py-3 rounded-none border-b-2 border-transparent
              //  data-[state=active]:border-primary"
              >
                Fare Detail
              </TabsTrigger> */}
          {/* </TabsList> */}
          {/* <TabsContent value="itinerary"> */}
          <Accordion
            open
            type="single"
            collapsible={false}
            className="w-full"
            defaultValue="itinerary"
          >
            <AccordionItem
              value='itinerary'
              className="border rounded-lg mb-3"
            >
              <AccordionTrigger className="hover:no-underline px-4 py-2 text-foreground border-b">
                <div className="flex gap-x-3 items-center">
                  <div className="">
                    <div className="flex gap-x-3">
                      <img
                        src={flightInfo.AirlineLogo}
                        alt=""
                        className="w-12 h:12 rounded object-contain"
                      />

                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center text-sm gap-x-1">
                      <span>{isOutbount ? "Departure" : "Return"}</span>
                      <span className="block">•</span>
                      <span>
                        {/* {moment(flightInfo.DepartureTime).format("lll")} */}
                        {moment(flightInfo.DepartureDate).format("ll")}
                      </span>
                    </div>
                    <div className="flex items-center text-xs lg:text-sm gap-x-1 text-muted-foreground">
                      <span>
                        {flightInfo.Origin} - {flightInfo.Destination}
                      </span>
                      <span className="block">•</span>
                      <span>
                        Non-Stop
                      </span>
                    </div>
                  </div>
                </div>
              </AccordionTrigger>

              <AccordionContent>
                <DomesticItineraryInfo flight={flightInfo} />
              </AccordionContent>
            </AccordionItem>


          </Accordion>
          {/* </TabsContent> */}
          {/* <TabsContent value="farerules">
              <PricingInfo
                info={{ FareOptions: flightInfo }
                }
                isPreview
              />
            </TabsContent> */}
          {/* </Tabs> */}
        </SheetDescription >
        <div className="flex items-center justify-between p-3 border-t">



          {/* {flightInfo.FareOptions && flightInfo.FareOptions.map((_) => {

              // the item should be selectable
              return (
                <span className="text-xl font-medium">
                  {_.Currency + " " + _.GTotalFare}
                </span>)
            })} */}
          {!isTwoWay && <Button
            onClick={() => {
              handleBookItemCallback(flightInfo);
            }}
          >
            Book
          </Button>}
        </div>
      </SheetContent >
    </Sheet >
  )
}

export default DomesticFlightDetailPreviewSheet
